import { render, staticRenderFns } from "./mx-page-layout.vue?vue&type=template&id=1a6fe587&scoped=true&"
import script from "./mx-page-layout.vue?vue&type=script&lang=js&"
export * from "./mx-page-layout.vue?vue&type=script&lang=js&"
import style0 from "./mx-page-layout.vue?vue&type=style&index=0&id=1a6fe587&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6fe587",
  null
  
)

export default component.exports